import styled from 'styled-components'
import { sizes } from 'config/ui'
import { PageTitle } from 'styles/common/Common.styles'
import { tokens } from '@arvoreeducacao/bonsai-core'

type StyledListProps = {
  isBook: boolean
}

export const StyledList = styled.div<StyledListProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => (props.isBook ? 'space-around' : 'center')};
  padding: 0 10px;

  @media (min-width: ${sizes.sScreen}px) {
    justify-content: flex-start;
    margin: 20px -10px;
    padding: 0;
  }
`

export const Title = styled(PageTitle)<{ isRouteTitle?: string }>`
  margin: 0px;
  font-size: 40px;

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    display: ${({ isRouteTitle }) => isRouteTitle && 'none'};
  }
`

export const Item = styled.div`
  position: relative;
  padding: 0 10px;
  width: 50%;
  max-width: 202px;
  height: auto;
  margin-bottom: 30px;

  @media (min-width: ${sizes.sScreen}px) {
    width: 202px;
    padding: 0px 10px 40px 10px;
    margin-bottom: 0;
    cursor: pointer;
  }

  @media (max-width: ${sizes.smallScreen}px) {
    padding: 0px 8px 0 8px;
  }

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 90%;
    max-width: none;
  }

  > a:first-child {
    border-radius: ${sizes.radius}px;
    display: block;
  }
`

type ItemGhostProps = {
  ghostItemWidth?: number
}

export const ItemGhost = styled(Item)<ItemGhostProps>`
  visibility: hidden;
  height: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0 !important;
  ${props =>
    props.ghostItemWidth ? `width: ${props.ghostItemWidth}px !important;` : ''};
`

export const ButtonsWrapper = styled.div`
  .icon-filter_list_sharp {
    margin-right: 8px;
  }

  margin: 0 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

type TopSectionProps = {
  flexDirection: string
}

export const TopSection = styled.div<TopSectionProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${sizes.sScreen}px) {
    align-items: flex-start;
    flex-direction: ${props => props.flexDirection || 'column'};
    padding-bottom: 16px;

    > div {
      padding: 0 20px;
      margin-bottom: 20px;
    }
  }
`
